import React from 'react'
import Loader from 'react-loader-spinner'
import '../styles/components/FormButton.css'

const FormButton = ({ onClick, loading, type, className, children }) => {
  return (
    <button onClick={onClick} type={type || 'submit'}
      className={`form-button-container
        ${loading ? 'form-button-loading' : ''}
        ${className || ''}`}>
      {loading ? (
        <Loader
          type='TailSpin'
          color='white'
          height='20'
          width='20'
        />
      ) : (
        children
      )}
    </button>
  )
}

export default FormButton



// WEBPACK FOOTER //
// ./src/components/FormButton.js